import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys/glossary';

import { getGlossaryTermCategoryInfo } from '@/features/glossary/api/getGlossaryTermCategoryInfo';
import type { GetGlossaryTermNameResponse } from '@/features/glossary/api/getGlossaryTermName';

type UseGlossaryTermCategoryInfoParams = {
  category: string;
};

export const useGlossaryTermCategoryInfo = ({ category }: UseGlossaryTermCategoryInfoParams) => {
  return useQueryWithBoundary({
    queryKey: glossaryKeys.categoryInfo(category),
    queryFn: async (): Promise<GetGlossaryTermNameResponse> => {
      return await getGlossaryTermCategoryInfo({ category });
    },
    enabled: !!category,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
